export const typeOptions = [
  {
    label: 'Telefonia',
    value: 'TELEFONIA'
  },
  {
    label: 'Lembrete',
    value: 'LEMBRETE'
  }
];

export const statusOptions = [
  {
    label: 'Agendado',
    value: 'AGENDADO'
  },
  {
    label: 'Cancelado',
    value: 'CANCELADO'
  }
];
